import { GlobalState } from "@sabyr-dev/mist_core/model/datasource/state";
import {
	CommonListModel, CommonSettingsModel, CommonStateModel
} from "@sabyr-dev/mist_core/model/impl/common";
import {
	OverviewMetadataModel, OverviewScoreModel
} from "@sabyr-dev/mist_core/model/impl/overview";
import {
	ReviewItemModel, ReviewMetadataModel
} from "@sabyr-dev/mist_core/model/impl/review";
import {
	TestItemModel, TestMetadataModel
} from "@sabyr-dev/mist_core/model/impl/test";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import {
	AcademyAttemptState, AcademyAttemptStateDataSource,
	AcademyAttemptTableRecord, AcademyGlobalStateDataSource,
	AcademyItemDataSource, AcademyListDataSource, AcademyMetadataDataSource,
	AcademyScoreDataSource, AcademySettingsDataSource
} from "./datasource";
import {
	AcademyAttemptStateModel, AcademyGlobalStateModel, AcademyItemModel,
	AcademyListModel, AcademyMetadataModel, AcademyScoreModel,
	AcademySettingsModel
} from "./model";

export class AcademyCommonListModel extends CommonListModel<Question> implements AcademyListModel {
	datasource: AcademyListDataSource;
}

export class AcademyCommonSettingsModel extends CommonSettingsModel<Product> implements AcademySettingsModel {
	datasource: AcademySettingsDataSource;

	setEmail(product: string, email: string): Promise<boolean> {
		return this.datasource.setEmail(product, email);
	}

	checkEmail(product: Product, email: string): Promise<boolean> {
		return this.datasource.checkEmail(product, email);
	}
}

export class AcademyCommonAttemptStateModel extends CommonStateModel<AcademyAttemptState> implements AcademyAttemptStateModel {
	datasource: AcademyAttemptStateDataSource;
}

export class AcademyCommonGlobalStateModel extends CommonStateModel<GlobalState> implements AcademyGlobalStateModel {
	datasource: AcademyGlobalStateDataSource;
}

export class AcademyReviewItemModel extends ReviewItemModel<Product, Attempt, Question> implements AcademyItemModel {
	// @ts-ignore
	datasource: AcademyItemDataSource;
}

export class AcademyReviewMetadataModel extends ReviewMetadataModel<Product, Attempt> implements AcademyMetadataModel {
	datasource: AcademyMetadataDataSource;

	setIncomplete(product: string, attempt: number): Promise<string> {
		return this.datasource.setIncomplete(product, attempt);
	}

	getTestUrl(): Promise<string> {
		return this.datasource.getTestUrl();
	}

	revertToLocalCookie(): Promise<void> {
		return this.datasource.revertToLocalCookie();
	}
}

export class AcademyTestItemModel extends TestItemModel<Product, Attempt, Question> implements AcademyItemModel {
	// @ts-ignore
	datasource: AcademyItemDataSource;

	// @ts-ignore
	setFinished(product: Product, attempt: Attempt, total_time: number): Promise<string> {
		return this.datasource.setFinished(product, attempt, total_time);
	}
}

export class AcademyTestMetadataModel extends TestMetadataModel<Product, Attempt> implements AcademyMetadataModel {
	datasource: AcademyMetadataDataSource;

	setIncomplete(product: string, attempt: number): Promise<string> {
		return this.datasource.setIncomplete(product, attempt);
	}

	getTestUrl(): Promise<string> {
		return this.datasource.getTestUrl();
	}

	revertToLocalCookie(): Promise<void> {
		return this.datasource.revertToLocalCookie();
	}
}

export class AcademyOverviewMetadataModel extends OverviewMetadataModel<Product, Attempt> implements AcademyMetadataModel {
	datasource: AcademyMetadataDataSource;

	setIncomplete(product: string, attempt: number): Promise<string> {
		return this.datasource.setIncomplete(product, attempt);
	}

	getTestUrl(): Promise<string> {
		return this.datasource.getTestUrl();
	}

	revertToLocalCookie(): Promise<void> {
		return this.datasource.revertToLocalCookie();
	}
}

export class AcademyOverviewScoreModel extends OverviewScoreModel<Attempt, Quiz> implements AcademyScoreModel {
	datasource: AcademyScoreDataSource;

	getAttempts(): Promise<AcademyAttemptTableRecord[]> {
		return this.datasource.getAttempts();
	}

	restoreAttempts(): Promise<void> {
		return this.datasource.restoreAttempts();
	}
}
